





































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Location} from 'vue-router';
import {Getter} from 'vuex-class';

import {ONLINE_SERVICES} from '@/site/constants';
import {Links} from '@/site/interfaces';

import AffluenceModal from './AffluenceModal.vue';
import LogoCuisineConnectee from './LogoCuisineConnectee.vue';

@Component({
  components: {AffluenceModal, LogoCuisineConnectee},
})
export default class AppBar extends Vue {
  @Getter('isDemo', {namespace: 'site'}) isDemo!: boolean;

  @Getter('logo', {namespace: 'site'}) logo!: string;

  @Getter('logo2', {namespace: 'site'}) logo2!: string | null;

  @Getter('links', {namespace: 'site'}) links!: Links;

  @Getter('hasArticles', {namespace: 'article'}) hasArticles!: boolean;

  @Getter('isBookingActivated', {namespace: 'site'}) isBookingActivated!: boolean;

  @Getter('enableContact', {namespace: 'site'}) enableContact!: boolean;

  @Getter('customerId', {namespace: 'site'}) customerId!: string;

  @Getter('enableAffluence', {namespace: 'site'}) enableAffluence!: boolean;

  affluenceDialog = false;

  services: {
    title: string;
    link?: string | null;
    name?: string;
    to?: Location;
    show: boolean;
  }[] = [];

  onlineServices: {
    title: string;
    link?: string | null;
    name?: string;
    to?: Location;
    show: boolean;
  }[] = [];

  @Watch('$store.state.site.links')
  setLinks(): void {
    if (this.links) {
      this.onlineServices = ONLINE_SERVICES.map((service) => ({
        title: service.title,
        link: this.links[service.linksField] || null,
        to: {
          name: 'onlineService',
          params: {slug: this.$route.params.slug, service: service.slug},
        },
        show: !!this.links[service.linksField],
      })).filter((service) => service.show);
    }
  }

  @Watch('$store.state.article.articles')
  showLocalService(): void {
    this.setServices();
  }

  mounted(): void {
    this.setServices();
    this.setLinks();
  }

  setServices(): void {
    if (this.hasArticles) {
      this.services = [
        {
          title: 'Menus',
          name: 'menu',
          show: true,
        },
        {
          title: 'Actualités',
          name: 'articles',
          show: this.hasArticles,
        },
        {
          title: 'Réservation',
          name: 'booking',
          show: this.isBookingActivated,
        },
        {
          title: 'Nous contacter',
          name: 'contact',
          show: this.enableContact,
        },
      ].filter((service) => service.show);
    } else {
      this.services = [
        {
          title: 'Menus',
          name: 'menu',
          show: true,
        },
        {
          title: 'Réservation',
          name: 'booking',
          show: this.isBookingActivated,
        },
        {
          title: 'Nous contacter',
          name: 'contact',
          show: this.enableContact,
        },
      ].filter((service) => service.show);
    }
  }

  selectService(service: {name: string; params: {id: string}}): void {
    this.$router.push(service);
  }
}
